<template>
  <el-dialog v-dialogDrag width="500px" title="修改目录模板" :visible.sync="dlgVisible" :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form :model="folder" size="small">
      <el-form-item label="新目录名称（必填）">
        <el-input v-model="folder.folderName" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="标签（只允许字母数字）">
        <el-input v-model="folder.sysTag" placeholder=""></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button type="primary" size="small" @click="confirmSubmit()">确定</el-button>
      <el-button size="small" @click="dlgVisible = false">关闭</el-button>
    </template>
  </el-dialog>
</template>

<script>
import folderTemplateService from "@/CommonDP/service/admin/folderTemplate-service";

export default {
  data() {
    return {
      dlgVisible: false,
      folder: {
        folderName: "",
        sysTag: ""
      }
    };
  },

  methods: {
    showDlg(folder) {
      this.folder = folder;
      this.dlgVisible = true;
    },
    async confirmSubmit() {
      if (!this.folder.folderName) {
        this.$error("请输入目录名称");
        return;
      }
      const json = {
        folderId: this.folder.folderId,
        folderName: this.folder.folderName,
        sysTag: this.folder.sysTag
      };
      await folderTemplateService.rename(json);
      this.$emit("ok");
      this.$success("重命名成功");
      this.dlgVisible = false;
    }
  }
};
</script>

<style></style>
